const checkShowAllFields = (formField) => {
  return formField?.appliedAt != null;
};

export default checkShowAllFields;
